namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmTrasaWorkflow extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmTrasaWorkflowReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmTrasaWorkflowObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmTrasaWorkflowObj());
            this.detailObj.createBase({
                contentName: "detailAdmTrasaWorkflow",
                contentCaption: "jres:33000796",  //RC 33000796 : Trasa dokumentů
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getKrokyTrasyTab());
                tabs.push(this.detailObj.getTypyDokumentuTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getKrokyTrasyGroup());
                groups.push(this.detailObj.getTypyDokumentuGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmTrasaWorkflow", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmTrasaWorkflowObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmTrasaWorkflowReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return `${this.data.ixs_tra}`
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmTrasaWorkflowSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmTrasaWorkflow.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmTrasaWorkflow", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmTrasaWorkflow.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.data.nazev}`;
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    favorite: true,
                    type: "static",
                    caption: "jres:33000138",
                    visible: this.options.newRecord == false,
                    icon: "fa-link",
                    children: [
                        { action: this.cnt.actions.actOpenAdmKrokyTrasy },
                        { action: this.cnt.actions.actOpenAdmTrasaProTypDokumentu }
                    ]
                },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenAdmKrokyTrasy: {
                    caption: "jres:33000799", //RC 33000799 : Kroky trasy
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.openAdmKrokyTrasy();
                    }
                },
                actOpenAdmTrasaProTypDokumentu: {
                    caption: "jres:33000831", //RC 33000831 : Typy dokumentů pro trasu
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.openAdmTrasaProTypDokumentu();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actOpenAdmKrokyTrasy?.update({ enabled: !editMode })
            this.cnt.actions.actOpenAdmTrasaProTypDokumentu?.update({ enabled: !editMode })
        }

        createForm() {
            //this.MakeField("ixs_tra")
            this.MakeField("nazev")
            this.MakeField("poznamka")
            this.MakeSelectField("priz_pov", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_pov = value.priz_an" })
            this.MakeSelectField("priz_pov_porad", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_pov_porad=value.priz_an" })
            this.MakeSelectField("priz_edit", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_edit=value.priz_an" })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        getKrokyTrasyTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-kroky-trasy",
                    title: "jres:33000799", //RC 33000775 : Parametry instance
                    opened: true,
                    locked: true,
                    group: { id: "_tab-kroky-trasy" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmKrokTrasy",
                    serverParams: {
                        ID: "SeznamAdmKrokTrasy",
                        ixs_tra: this.data.ixs_tra,
                        tabOpen: true
                    }
                }
            }
        }

        getKrokyTrasyGroup(): IGTabGroupOptions {
            return { id: "_tab-kroky-trasy", caption: "jres:33000799" }
        }

        getTypyDokumentuTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-typy-dokumentu",
                    title: "jres:33000833", //RC 33000833 : Typy dokumentů
                    opened: true,
                    locked: true,
                    group: { id: "_tab-typy-dokumentu" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmTrasaProTypDokumentu",
                    serverParams: {
                        ID: "SeznamAdmTrasaProTypDokumentu",
                        ixs_tra: this.data.ixs_tra,
                        tabOpen: true
                    }
                }
            }
        }

        getTypyDokumentuGroup(): IGTabGroupOptions {
            return { id: "_tab-typy-dokumentu", caption: "jres:33000833" }
        }

        private openAdmKrokyTrasy() {
            $.content().navigate(["Gordic.Adm.WebControls.SeznamAdmKrokTrasy", {
                ixs_tra: this.data.ixs_tra
            }])
        }

        private openAdmTrasaProTypDokumentu() {
            $.content().navigate(["Gordic.Adm.WebControls.SeznamAdmTrasaProTypDokumentu", {
                ixs_tra: this.data.ixs_tra
            }])
        }
    }
}